import { CompactTabItem } from 'components/nav/CompactTabMenu/CompactTab';

import { EventContext } from 'models/event.model';

export interface EventContextLabel {
    value: EventContext;
    label: string;
    info: string;
}

export const EventContextLabels: EventContextLabel[] = [
    {
        value: EventContext.positive,
        label: 'Positive',
        info: 'A desirable user outcome. Agents treat this as a success signal during learning. Examples: purchase, add to cart, content consumed.',
    },
    {
        value: EventContext.ignore,
        label: 'Irrelevant',
        info: 'Events that should not be used as feedback. Agents ignore these when learning. Examples: test events, internal QA actions.',
    },
    {
        value: EventContext.negative,
        label: 'Negative',
        info: 'An undesirable user outcome. Agents treat this as a failure signal during learning. Examples: unsubscribe, churn, permanent opt-out.',
    },
];

export enum EventsTab {
    AllEvents = 'AllEvents',
    UncategorizedEvents = 'UncategorizedEvents',
}

export const EventTabOptions: CompactTabItem[] = [
    {
        key: EventsTab.AllEvents,
        name: 'All events',
    },
    {
        key: EventsTab.UncategorizedEvents,
        name: 'Uncategorized events',
    },
];
